<template>
  <div
    class="eventview-bets">
    <div
      class="bet-builder-info-message-wrap"
      v-if="selectedBetGroupId === 'betBuilder'">
      <div class="bet-builder-info-message">
        <em class="icon icon-info" />
        {{ $translate.key('bet_builder_info_message') }}
      </div>
    </div>
    <EmptyListMessage
      v-if="selectedBetGroupId === 'betBuilder' && !betBuilderEventBets.length"
      message="bet_builder_empty_markets_message" />
    <div
      class="eventview-bets-list scrollbar"
      :class="{'back-to-top-padding': !scrollButtonsEnabled && isContentScrolled}"
      ref="eventviewBets">
      <EventviewBet
        v-for="(bet, index) in betsByGroup"
        :key="index"
        :selected-bet-group="selectedBetGroup || {}"
        :match-betting-status="matchBettingStatus"
        :bet="bet"
        :id-match="idMatch"
        :id-sport="idSport"
        :bet-index="index"
        :bet-builder-bets="betBuilderEventBets"
      />
      <ScrollButtons
        v-if="scrollButtonsEnabled"
        :key="allBetsCount"
        :class="{'bottom-position-adjust': betslipButtonVisible }"
        scroll-content="eventview-bets-list"
        :has-scroll-to-top="true" />
    </div>
  </div>
</template>

<script>
import {
  computed, watch, toRef, onUnmounted, onDeactivated, ref,
} from 'vue';
import { useStore } from 'vuex';
import EmptyListMessage from '@/components/common/EmptyListMessage';
import EventviewBet from './EventviewBet';
import ScrollButtons from '@/components/common/ScrollButtons';
import useMatchBets from '@/composables/matchBets';

export default {
  name: 'EventviewBets',
  components: {
    EmptyListMessage,
    EventviewBet,
    ScrollButtons,
  },
  props: {
    bets: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    selectedBetGroup: {
      type: Object,
      required: true,
    },
    matchBettingStatus: {
      type: Boolean,
      required: true,
    },
    idMatch: {
      type: String,
      required: true,
    },
    scrollButtonsEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    betslipButtonVisible: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },
    idSport: {
      type: String,
      required: true,
    },
    allBetsCount: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const eventviewBets = ref();
    const { selectedBetGroupId } = useMatchBets();

    const betsByGroup = computed(() => {
      if (!props.selectedBetGroup.idBetGroup) return props.bets;

      return props.bets.filter((
        { idBet },
      ) => props.selectedBetGroup?.bets?.find((_bet) => idBet === _bet));
    });

    const betBuilderEventSelection = computed(() => store.getters.betBuilderEventSelection);

    const betBuilderEventBets = computed(() => {
      const betBuilderEvent = betBuilderEventSelection.value[Number(props.idMatch)] || {};
      return betBuilderEvent.markets || [];
    });

    const isContentScrolled = computed(() => store.getters.isScrolled);

    const betAssistEnabled = computed(() => store.getters.config?.srWidgets?.betAssist?.enabled);
    const removeBetAssist = () => {
      if (!betAssistEnabled.value) return;

      store.dispatch('updateBetAssistPopupId');
      window.SIR('removeWidget', '.bet-assist');
    };

    const eventviewScrollPosKeys = computed(() => [
      store.getters.activeView,
      store.getters.selectedBetGroupId,
      store.getters.selectedMatchId,
    ]);

    watch(eventviewScrollPosKeys, () => {
      eventviewBets.value.scrollTop = 0;
    });

    watch(toRef(props, 'idMatch'), () => removeBetAssist());

    // Triggered when array of Eventview Bets gets emptied (when no bets available)
    onUnmounted(() => {
      removeBetAssist();
    });

    // Triggered when we switch to Overview tab or when we leave iframe completely
    onDeactivated(() => {
      removeBetAssist();
    });

    return {
      betBuilderEventBets,
      betsByGroup,
      isContentScrolled,
      selectedBetGroupId,
      eventviewBets,
    };
  },
};
</script>
